/**
 * 国际化配置文件
 * SC:中文
 * TC:繁体
 */
export default {
   upperLimitNoIsNull: { SC: "上限不能为空", TC: "上限不能為空", EN: "Upper Limit is required." }
   , download: { SC: "下载中...", TC: "下載中...", EN: "Downloading..." }
   , downloadParam: { SC: "系统参数.xlsx", TC: "系統參數.xlsx", EN: "System Parameters.xlsx" }
   , segmentName: { SC: "参数名称", TC: "參數名稱", EN: "Segment Name" }
   , segmentNameNoIsNull: { SC: "参数名称不能为空", TC: "參數名稱不能為空", EN: "Segment Name is required." }
   , code: { SC: "编码", TC: "編碼", EN: "Code" }
   , codeNoIsNull: { SC: "编码不能为空", TC: "編碼不能為空", EN: "Code is required." }
   , description: { SC: "描述", TC: "描述", EN: "Description" }
   , descriptionNoIsNull: { SC: "描述不能为空", TC: "描述不能為空", EN: "Description is required." }
   , longDesc: { SC: "详细描述", TC: "詳細描述", EN: "Detailed Description" }
   , parmValue1: { SC: "属性1", TC: "屬性1", EN: "Attrib01" }
   , parmValue2: { SC: "属性2", TC: "屬性2", EN: "Attrib02" }
   , parmValue3: { SC: "属性3", TC: "屬性3", EN: "Attrib03" }
   , parmValue4: { SC: "属性4", TC: "屬性4", EN: "Attrib04" }
   , parmValue5: { SC: "属性5", TC: "屬性5", EN: "Attrib05" }
   , parmValue6: { SC: "属性6", TC: "屬性6", EN: "Attrib06" }
   , activeInd: { SC: "是否激活", TC: "是否激活", EN: "Active" }
   , activeIndNoIsNull: { SC: "是否激活不能为空", TC: "是否激活不能為空", EN: "Active is required." }
   , dispSeq: { SC: "序号", TC: "序號", EN: "Seq" }
   , downloadExcel: { SC: "导出Excel表格", TC: "匯出Excel表格", EN: "Download Report" }
   , noIsNull: { SC: "不能为空", TC: "不能為空", EN: " is required." }
   , param: { SC: "系统参数", TC: "系統參數", EN: "System Parameters" }
   , sysManagement: { SC: "系统管理", TC: "系統管理", EN: "System" }
   , selectiveData: { SC: "请选择一条数据", TC: "請選擇一條數據", EN: "Please select a reord." }
   , deleteData: { SC: "数据删除中...", TC: "數據删除中...", EN: "Data is processing..." }
   , deleteSuccess: { SC: "删除成功", TC: "刪除成功", EN: "Deleted successfully." }
   , beQuerying: { SC: "查询中...", TC: "査詢中...", EN: "Searching..." }
   , noneDate: { SC: "找不到符合条件记录.", TC: "找不到符合條件記錄.", EN: "No record is founed." }
   , saveSuccess: { SC: "保存成功", TC: "保存成功", EN: "Saved successfully." }
   , controls: { SC: "操作", TC: "操作", EN: "Operation" }
   , add: { SC: "Add", TC: "Add", EN: "Add" }
   , dataBeSaving: { SC: "数据保存中...", TC: "數據保存中...", EN: "Data is processing..." }
   , sysManage: { SC: "系统管理", TC: "系統管理", EN: "System" }
 
   , save: { SC: "Save", TC: "Save", EN: "Save" }
   , cancel: { SC: "Cancel", TC: "Cancel", EN: "Cancel" }
   , delete: { SC: "Delete", TC: "Delete", EN: "Delete" }
   , audit: { SC: "Log", TC: "Log", EN: "Log" }
   , list: { SC: "List", TC: "List", EN: "List" }
   , search: { SC: "Search", TC: "Search", EN: "Search" }
   , reset: { SC: "Reset", TC: "Reset", EN: "Reset" }
    ,academicStaffId: { EN:"CNA" }
    ,baseProgId: { EN:"Base Programme" }
    ,userIdIsNull: { EN:"Academic ID is required." }
    ,academicStaffName: { EN:"Academic Name" }
    ,academicStaffSurnameIsNull:{EN:"Academic Name is required."}
    ,userAccountManagementAcademicStaff: { EN:"Academic" }
    ,create: {EN:"Create" }
    ,update: { EN: "Edit" }
    ,view: { EN: "View" }
    ,batchUpload: {  EN: "Batch Upload" }
    ,saveUpload: { EN: "Save & Upload" }
    ,academicStaffSurname: { EN: "Academic Name" }
    ,academicStaffGivenName: { EN: "Staff Saluation" }
    ,staffSaluationIsNull: { EN: "Staff Saluation is required." }
    ,academicStaffProgramme: { EN: "Inactive Date" }
    ,programme: { EN: "Programme" }
    ,phone: { EN: "Phone" }
    ,birth: { EN: "Birth" }
    ,email: { EN: "Email" }
    ,status: { EN: "Status" }
    ,activeIndIsNull: { EN: "Status is required." }
    ,teacherCategoryIsNull: { EN: "Teacher Category is required." }
    ,teacherCategory: { EN: "Teacher Category" }
    ,inactiveDateIsNull:{EN: "Inactive Date is required."}
    ,progLaunchYear: { SC:"", TC: "", EN: "Launch Year" }
    ,deptCode: { SC:"", TC: "", EN: "Department" }
    ,progCode: { SC:"", TC: "", EN: "Programme Code" }
    ,progTitle: { SC:"", TC: "", EN: "Programme Name" }
    ,settingsImg: { SC:"设置图片", TC: "設定圖片", EN: "Upload Photo" }
    ,deleteImg: { SC:"您确定要删除该图片吗？", TC: "您確定要刪除該圖片嗎？", EN: "Confirm delete Photo?" }
    ,ok: { SC:"确定", TC: "確定", EN: "Confirm" }
    ,firstName: { SC:"", TC: "", EN: "First Name" }
    ,firstNameIsNoNull: { SC:"", TC: "", EN: "First Name is required." }
    ,lastName: { SC:"", TC: "", EN: "Last Name" }
    ,lastNameIsNoNull: { SC:"", TC: "", EN: "Last Name is required." }  
    ,notificationInd: { EN: "Notification" }
    ,notificationIndIsNull: { EN: "Notification is required." }
 }